export default {
  'monthNames': [
    'Gennaio',
    'Febbraio',
    'Marzo',
    'Aprile',
    'Maggio',
    'Giugno',
    'Luglio',
    'Agosto',
    'Settembre',
    'Ottobre',
    'Novembre',
    'Dicembre'
  ],
  'dayNames': [
    'Do',
    'Lu',
    'Ma',
    'Me',
    'Gi',
    'Ve',
    'Sa'
  ]
}



// WEBPACK FOOTER //
// ./src/locale/it/index.js